/** docs.fastn.ai pages the onboarding links to. Checked against the site's llms.txt. */
const DOCS = "https://docs.fastn.ai";

export const DOCS_LINKS = {
  onboarding: `${DOCS}/fastn/readme/onboarding`,
  connectProduct: `${DOCS}/fastn/readme/onboarding/connect-your-product`,
  chooseIntegrations: `${DOCS}/fastn/readme/onboarding/choose-integrations`,
  embedWidget: `${DOCS}/fastn/readme/onboarding/embed-the-widget`,
  customersStep: `${DOCS}/fastn/readme/onboarding/customers-connect-and-customize`,
  connectProductInOnboarding: `${DOCS}/fastn/readme/onboarding/connect-your-product#in-the-onboarding`,
  connectProductWays: `${DOCS}/fastn/readme/onboarding/connect-your-product#ways-to-do-it`,
  connectProductDirection: `${DOCS}/fastn/readme/onboarding/connect-your-product#use-cases-and-scenarios`,
  chooseIntegrationsWays: `${DOCS}/fastn/readme/onboarding/choose-integrations#ways-to-do-it`,
  chooseIntegrationsParts: `${DOCS}/fastn/readme/onboarding/choose-integrations#what-its-made-of`,
  embedWidgetSetup: `${DOCS}/fastn/readme/onboarding/embed-the-widget#developer-setup`,
  gettingStarted: `${DOCS}/fastn/readme`,
  quickstart: `${DOCS}/fastn/readme/quickstart`,
  concepts: `${DOCS}/fastn/readme/concepts`,
  mcp: `${DOCS}/build/mcp-gateway`,
  mcpClaude: `${DOCS}/build/mcp-gateway/claude`,
  mcpChatgpt: `${DOCS}/build/mcp-gateway/chatgpt`,
  apiKeys: `${DOCS}/tutorials/developer/authentication-and-api-keys`,
  embedTokens: `${DOCS}/tutorials/developer/generating-embed-tokens`,
  embedIframe: `${DOCS}/embed/embedding/iframe`,
  widgetBuilder: `${DOCS}/embed/widget-builder`,
  aiCredits: `${DOCS}/manage/billing`,
  managingCustomers: `${DOCS}/tutorials/saas-admin/managing-customers`,
  customerCustomizes: `${DOCS}/tutorials/end-user/customizing-your-integrations`,
} as const;
